import { useTranslation } from 'react-i18next';
import type { PlatformAnnouncement } from '../../api/config';
import { ModalSheet } from '../ui/ModalSheet';
import { formatAnnouncementBody, formatAnnouncementDate } from '../../utils/announcement-display';

export function AnnouncementDetailModal({
  item,
  onClose,
}: {
  item: PlatformAnnouncement | null;
  onClose: () => void;
}) {
  const { t, i18n } = useTranslation();
  if (!item) return null;

  const body = formatAnnouncementBody(item.body ?? '');

  return (
    <ModalSheet open onClose={onClose} title={t('news.detail')}>
      <h2 className="text-base font-semibold leading-snug text-text-primary">{item.title}</h2>
      <time className="mt-2 block text-[11px] text-text-secondary">
        {formatAnnouncementDate(item.create_time, i18n.language)}
      </time>
      <p className="mt-4 whitespace-pre-wrap text-sm leading-relaxed text-text-primary">
        {body || t('news.emptyBody')}
      </p>
      <button type="button" className="btn-primary mt-5 w-full" onClick={onClose}>
        {t('common.close')}
      </button>
    </ModalSheet>
  );
}
